/* eslint import/no-webpack-loader-syntax: off */
import pages from '!import-glob!./pages-loader';

pages.forEach((page) => {
    // Add a footer to each page
    page.elements.push(
        {
            name: `notes-${page.name}`,
            // @ts-ignore
            title: `${page.title} notes or comments`,
            type: 'comment',
        },
        {
            type: 'html',
            html: '<span style="color: red;font-weight: 800;font-size: 2em;">*</span> Indicates required field',
        }
    );
});

let pageLookup: { [key: string]: string } = {};
let names: string[] = []

pages.forEach((page) => {

    page.elements.forEach((el: any) => {
        if (!!el.name) {
            pageLookup[(el.name as string)] = page.name;
        }
        if (el.type === 'panel') {
            el.elements.forEach((subEl: any) => {
                if (!!subEl.name) {
                    pageLookup[(subEl.name as string)] = page.name;
                }
            });
        }
        if (el.name === 'purpose') {
            el.choices.forEach((choice: any) => {
                if (typeof choice === 'string') {
                    names.push(choice);
                } else if (typeof choice.value === 'string') {
                    names.push(choice.value);
                }
            });
        }
    });
});

export const pageNameFor = pageLookup;
export const pageNames = names;

export default pages;
